// Wills & estate / IHT plan settings (mirrors ESTATE_PLAN_FIELDS in
// app/serializers.py): defaults for the plan store and plan loading.
export const ESTATE_SETTING_DEFAULTS = {
  include_pension_in_estate: true,
  apply_rnrb_downsizing_addition: true,
  clt_tax_paid_by_settlor: false,
  gift_fund_from_partner: true,
  will_spouse_percent_person_one: 100,
  will_spouse_percent_person_two: 100,
  will_descendants_percent_person_one: 100,
  will_descendants_percent_person_two: 100,
  will_charity_percent_person_one: 0,
  will_charity_percent_person_two: 0,
  will_other_percent_person_one: 0,
  will_other_percent_person_two: 0,
  pension_to_spouse_person_one: true,
  pension_to_spouse_person_two: true,
  home_to_descendants_person_one: false,
  home_to_descendants_person_two: false,
};

// { field: data[field] ?? default } - copies the settings from a loaded plan.
export const estateSettingFieldsFrom = (data) =>
  Object.fromEntries(Object.entries(ESTATE_SETTING_DEFAULTS).map(([name, def]) => [name, data[name] ?? def]));

// Will split (descendants / charity / other) for a person - must total 100.
export const willSplitTotal = (presetObject, person) =>
  ['descendants', 'charity', 'other'].reduce((t, part) => t + (Number(presetObject[`will_${part}_percent_${person}`]) || 0), 0);
